/*global payment, paymentCommon */

var creditCard = {
    number: null,
    init: function() {
        this.cardNumber();
        this.formatCCV();
        this.cardExplainCCV();
    },
    cardNumber: function() {
        const inputCardNumber = $('.input-card-number');
        const CCV_MAXLENGTH = 3;
        const AMEX_CCV_MAXLENGTH = 4;

        inputCardNumber.on('change paste input', function() {
            const t = $(this);
            const card = creditCard.cardFromNumber(t.val());
            const cardNumber = creditCard.formatCardNumber(t.val());

            creditCard.setValue(cardNumber, inputCardNumber);

            $('#ccType').val(card.value);

            if (t.val() !== '') {
                inputCardNumber.parent().removeClass('amex discover maestro mastercard visa unknown').addClass(card.type);
                $('#ccTypeName').val(card.type);
                $('#ccCCV').attr('maxlength', card.type === 'amex' ? AMEX_CCV_MAXLENGTH : CCV_MAXLENGTH);

                if (card.type === 'amex') {
                    creditCard.amexNotify();
                } else {
                    creditCard.removeAmexNotify();
                }
            } else {
                $('#ccTypeName').val('-1');
                inputCardNumber.parent().removeClass('amex discover maestro mastercard visa unknown');
                creditCard.removeAmexNotify();
            }
        });
    },
    cards: [
        {
            type: 'amex',
            pattern: [34, 37],
            format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
            length: [15],
            cvcLength: [3, 4],
            luhn: true,
            value: 1
        },
        {
            type: 'mastercard',
            pattern: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
            format: /(\d{1,4})/g,
            length: [16],
            cvcLength: [3],
            value: 2
        },
        {
            type: 'visa',
            pattern: [4],
            format: /(\d{1,4})/g,
            length: [16, 18, 19],
            cvcLength: [3],
            luhn: true,
            value: 3
        },
        {
            type: 'maestro',
            pattern: [
                493698,
                [500000, 504174],
                [504176, 506698],
                [506779, 508999],
                [56, 59],
                63,
                67,
                6
            ],
            format: /(\d{1,4})/g,
            length: [12, 13, 14, 15, 16, 17, 18, 19],
            cvcLength: [3],
            luhn: true,
            value: 4
        },
        {
            type: 'discover',
            pattern: [6011, [644, 649], 65],
            format: /(\d{1,4})/g,
            length: [16],
            cvcLength: [3],
            luhn: true,
            value: 5
        }
    ],
    cardFromNumber: function(num) {
        const cards = creditCard.cards;

        num = (String(num)).replace(/\D/g, '');

        const bin = creditCard.getBin(num);
        const detectedTypes = [];

        cards.forEach(card => {
            card.pattern.forEach(pattern => {
                if (creditCard.checkCard(bin, pattern)) {
                    detectedTypes.unshift(card);
                }
            });
        });

        return detectedTypes[0] || {
            type: 'unknown',
            format: /(\d{1,4})/g,
            length: [16],
            cvcLength: [3],
            luhn: false,
            value: -1
        };
    },
    getBin: function(value) {
        return value.toString().replace(/\D/g, '').substring(0, 6);
    },
    checkCard: function(bin, pattern) {
        return Array.isArray(pattern)
            ? creditCard.checkRange(bin, pattern)
            : creditCard.checkPattern(bin, pattern);
    },
    checkPattern: function(bin, pattern) {
        if (pattern instanceof RegExp) {
            return pattern.test(bin);
        }

        pattern = pattern.toString();
        return bin.substring(0, pattern.length) === pattern;
    },
    checkRange: function(bin, [min, max]) {
        const length = min.toString().length;
        const value = parseInt(bin.substring(0, length));

        return value >= min && value <= max;
    },
    luhnCheck: function(num) {
        let sum = creditCard.luhnSum(num);
        return sum % 10 === 0;
    },
    luhnSum: function(num) {
        let digit, digits, odd, sum, _i, _len;
        odd = true;
        sum = 0;
        digits = (String(num)).split('').reverse();
        for (_i = 0, _len = digits.length; _i < _len; _i++) {
            digit = digits[_i];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
                digit *= 2;
            }
            if (digit > 9) {
                digit -= 9;
            }
            sum += digit;
        }

        return sum;
    },
    formatCardNumber: function(num) {
        var card, groups, ref, upperLength;
        num = num.replace(/\D/g, '');
        card = creditCard.cardFromNumber(num);

        if (!card) {
            return num;
        }
        upperLength = card.length[card.length.length - 1];
        num = num.slice(0, upperLength);

        if (card.format.global) {
            return (ref = num.match(card.format)) !== null ? ref.join(' ') : void 0;
        } else {
            groups = card.format.exec(num);
            if (groups === null) {
                return;
            }
            groups.shift();
            groups = groups.filter(Boolean);
            return groups.join(' ');
        }
    },
    validateCardNumber: function(num, event) {
        var card, _ref, response;
        num = (String(num)).replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
            return false;
        }
        card = creditCard.cardFromNumber(num);
        if (!card) {
            return false;
        }

        response = (_ref = num.length, [].indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || creditCard.luhnCheck(num));
        if (!response && ['blur', 'change'].indexOf(event) >= 0 && num.length >= card.length[0]) {
            creditCard.logFailedLuhnTest(num, {ccBrand: card.type, ccLength: num.length, ccLuhnSum: creditCard.luhnSum(num), number: payment.domElements.number.val()});
            creditCard.number = num;
        }

        return response;
    },
    logFailedLuhnTest: function(num, request) {
        if (creditCard.number !== num) {
            $.postJSON(_d.url.payments.logFailedLuhnTest, request);
        }
    },
    formatCCV: function() {
        $('#ccCCV').on('input blur paste', function() {
            let that = $(this);
            that.val((String(that.val())).replace(/\D/g, ''));
        });
    },
    cardExplainCCV: function() {
        var ccv = $('.ccv-info');

        if (ccv.data('image')) {
            $('body').append('<div class="tooltip-image" id="what-is-cvv"><img src="' + _d.url.host + ccv.data('image') + '" width="49" height="30" /></div>');

            const cvv = $('#what-is-cvv');
            ccv.mouseover(function() { cvv.css({opacity: 1, display: 'none'}).fadeIn(300); })
                .mousemove(function(m) { cvv.css({left: m.pageX+15, top: m.pageY-50}); })
                .mouseout(function() { cvv.fadeOut(100); });
        }
    },
    amexNotify: function() {
        let paymentCurrency = $('#paymentCurrency').val();
        let amexNotAllowedCurrencies = ['BRL'];
        if (amexNotAllowedCurrencies.indexOf(paymentCurrency) >= 0 ) {
            paymentCommon.addPaymentErrors(_d.t.notAbleToProcessPaymentUsingAmex.replace('{currency}', paymentCurrency));
        } else {
            creditCard.removeAmexNotify();
        }
    },
    removeAmexNotify: function() {
        paymentCommon.removePaymentErrors('errorBlock');
    },
    setValue: function(value, target) {
        let currPair, cursor, digit, last, prevPair;

        try {
            cursor = target.prop('selectionStart');
        } catch (e) {
            cursor = null;
        }
        last = target.val();
        target.val(value);

        if (cursor !== null && target.is(':focus') && typeof value !== 'undefined') {
            if (cursor === last.length) {
                cursor = value.length;
            }
            if (last !== value) {
                prevPair = last.slice(cursor - 1, Number(cursor) + 1 || 9e9);
                currPair = value.slice(cursor - 1, Number(cursor) + 1 || 9e9);
                digit = value[cursor];
                if (/\d/.test(digit) && prevPair === (String(digit) + ' ') && currPair === (' ' + digit)) {
                    cursor = cursor + 1;
                }
            }
            target.prop('selectionStart', cursor);
            target.prop('selectionEnd', cursor);
        }
    }
};
